import { Type } from 'theme/types';
import styled from "styled-components";

export const ComingSoonContainer = styled.div`
    ${({ theme }: Type) => theme?.comingSoonConfig?.comingSoonBackground}
`
export const ComingSoonImage = styled.div`
    ${({ theme }: Type) => theme?.comingSoonConfig?.comingSoonImage}
`
